const img = require('./porchSideA.svg'); export default img;